export default "__VITE_ASSET__BgReAlOt__"